import React, { PureComponent } from 'react'
import PropTypes from "prop-types"
import {intlShape} from "react-intl"


import redirectToApp from '../utils/redirectToApp'
import appConst from '../constant/appConst'

class ReadMoreComponent extends PureComponent {
	constructor(props) {
		super(props)
		this.onLinkClick = this.onLinkClick.bind(this)
	}

	onLinkClick() {
		const { type, id } = this.props
		redirectToApp(type, id)
	}

	render() {
		const { className } = this.props
		const {intl} = this.context
		return (
			<a className={className} onClick={this.onLinkClick}>
				{intl.formatMessage({id: 'buttons.readmore'})}
			</a>
		)
	}
}

ReadMoreComponent.propTypes = {
	id: PropTypes.string.isRequired,
	type: PropTypes.oneOf(['story', 'playlist', 'track', 'album', 'artist'])
}

ReadMoreComponent.contextTypes = {
	intl: intlShape
}

ReadMoreComponent.defaultProps = {
	className: 'infos__button pct pct-carret-link'
}

export default ReadMoreComponent



// WEBPACK FOOTER //
// ./src/components/ReadMoreComponent.js